import { TrustPilotRoutes } from '/@/modules/trustpilot/constants/TrustPilotRoutes';

export const ReviewRoute = {
  LAYOUT: {
    name: 'review-layout',
    path: '/'
  },
  REVIEW: {
    name: 'review',
    path: `/${TrustPilotRoutes.REVIEW}/:estateAccountId/:trustPilotReviewId`
  }
};
